import { v4 as uuid } from 'uuid';

import {
  setSubscribeUsersStatusFailed,
  setSubscribeUsersStatusPending,
  setSubscribeUsersStatusSuccess,
} from './actions';
import { ERequestApiStatus, EWsClientEventType } from '../../types/appState';
import { TThunkAction } from '../../types/redux/thunk';
import { ISessionSucceedState } from '../../types/session';
import { ETelemetryEvents } from '../../types/telemetry';
import { IWSClientSubscribeUsersStatusSchema } from '../../types/usersStatus';
import { timeoutPromise } from '../../utils/timeoutPromise';
import { EInternetStatus } from '../internetStatus';
import { setSocketFailed } from '../socket';

/**
 * Подписка по сокету на получение статуса по массиву id пользователей
 */
export const subscribeUsersStatus =
  (requestedUserIds: number[]): TThunkAction<Promise<void>> =>
  async (dispatch, getState, { logger, telemetry }) => {
    const {
      session: { status, token },
      socket: { clientEvents, eventChannel, status: socketStatus },
      internetStatus,
    } = getState();

    dispatch(setSubscribeUsersStatusPending());

    const isSessionExpired = status !== ERequestApiStatus.Succeed;
    const isSocketIsClose = eventChannel.isChannelClosed() || socketStatus === ERequestApiStatus.Failed;
    const isOffline = internetStatus === EInternetStatus.Offline;

    const uid = uuid();

    if (isSocketIsClose) {
      dispatch(setSocketFailed());
    }

    if (isSessionExpired || isSocketIsClose || isOffline) {
      clientEvents.set(uid, { type: EWsClientEventType.SubscribeUsersStatus, status: ERequestApiStatus.Failed });
      dispatch(setSubscribeUsersStatusFailed());

      return;
    }

    const wsStatusEvent: IWSClientSubscribeUsersStatusSchema = {
      type: 'status',
      uid,
      userId: (token as ISessionSucceedState['token']).userId,
      sessionToken: (token as ISessionSucceedState['token']).sessionToken,
      requestedUserIds,
      action: 'subscribe',
    };

    clientEvents.set(uid, {
      status: ERequestApiStatus.Pending,
      type: EWsClientEventType.SubscribeUsersStatus,
    });

    try {
      await timeoutPromise(eventChannel.subscribeUsersStatus(wsStatusEvent), 10000);
      dispatch(setSubscribeUsersStatusSuccess());
    } catch (err) {
      logger.warning(err, {
        domain: 'frontend-chats.subscribeUsersStatus.ts',
        message: 'Не удалось подписаться на статус пользователей по ws',
      });
      telemetry.increment(ETelemetryEvents.ChatWsUserStatusFail);

      clientEvents.set(uid, { type: EWsClientEventType.SubscribeUsersStatus, status: ERequestApiStatus.Failed });
      dispatch(setSubscribeUsersStatusFailed());
    }
  };
